/**
 * User: WangMeng
 * Desc: 日志详情弹框
 */
import styles from './detaiModal.scss';
import React from 'react';
import { Link } from 'react-router';
import cns from 'classnames';
import { Modal, Table } from 'antd';
import { PicturePageText, PicturePageLink } from '../../../../constants/info';
import messager from '../../../../utils/messager';
import { isNotEmpty, getPictureLink } from '../../../../utils/util';
import { dateFormat } from '../../../../utils/formatter';
import GroupBox from '../../../common/groupBox/GroupBox';
import Ellips from '../../../common/ellipsisAndTooltip/EllipsisAndTooltip';
import Pagination from '../../../common/pagination/Pagination';
import TableSearch from '../../../common/tableSearch/TableSearch';
import { getLogDetailList, delLog } from '../../../../services/user';
const confirm = Modal.confirm;

export default class DetailModal extends TableSearch {
    constructor(props) {
        super(props);
        const { companyCode, reportDateType, reportType, reportYear } = props.item;
        this.server = getLogDetailList;

        this.state = {
            loading: false,
            searchParams: {
                companyCode,
                reportDateType,
                reportType,
                reportYear
            },
            pageNum: 1,
            pageSize: 10,
            total: 0,
            data: [],
            selectedRowKeys: []
        };
    }

    componentDidMount() {
        if(isNotEmpty(this.props.item)) {
            this.getData();
        }
    }

    beforeGetData = () => {
        this.setState({
            loading: true,
            selectedRowKeys: []
        });
    };

    delData = () => {
        confirm({
            title: '确认删除日志?',
            width: 350,
            onOk: () => {
                const { selectedRowKeys, data, pageNum } = this.state;
                delLog({
                    id: selectedRowKeys.join(',')
                }).then(() => {
                    if (selectedRowKeys.length === data.length && pageNum === 1) { // 详情数据全部删除后，外部列表更新
                        const { onDelAll } = this.props;
                        onDelAll && onDelAll();
                    }

                    // 更新列表
                    this.delRefresh(selectedRowKeys.length);
                    messager.success('删除成功');
                });
            }
        });
    };

    selectRowChange = (selectedRowKeys) => {
        this.setState({ selectedRowKeys });
    };

    getPopupContainer = () => {
        return document.querySelector('.log-detail-modal');
    };

    getColumns = () => {
        return [{
            title: '日志日期',
            dataIndex: 'createTime',
            width: 100,
            render: dateFormat
        }, {
            title: '公司简称',
            dataIndex: 'sesName',
            width: 100,
            render: (v, d) => <Link target="_blank" rel="noopener noreferrer" to={getPictureLink(d, PicturePageLink[d.module])}>{v}</Link>
        }, {
            title: '所属模块',
            dataIndex: 'module',
            width: 110,
            render: (v) => PicturePageText[v]
        }, {
            title: '异常描述',
            dataIndex: 'description',
            render: (v) => <Ellips text={v} max={63} getPopupContainer={this.getPopupContainer}/>
        }, {
            title: '监管方向',
            dataIndex: 'direction',
            render: (v) => <Ellips text={v} max={63} getPopupContainer={this.getPopupContainer}/>
        }, {
            title: '备注',
            dataIndex: 'remark',
            width: 180,
            render: (v) => <Ellips text={v} max={40} getPopupContainer={this.getPopupContainer}/>
        }];
    };

    render() {
        const { visible, onCancel } = this.props;
        const { data, loading, selectedRowKeys, total, pageNum, pageSize } = this.state;

        return (
            <Modal
                wrapClassName="log-detail-modal"
                width={1080}
                onCancel={onCancel}
                visible={visible}
                footer={null}
            >
                <GroupBox title="日志详情">

                    <button
                        type="button"
                        disabled={!selectedRowKeys.length}
                        className={cns('btn btn-blue', styles.delButton)}
                        onClick={this.delData}
                    >删除</button>

                    <Table
                        rowKey="id"
                        loading={loading}
                        pagination={false}
                        rowSelection={{ selectedRowKeys, onChange: this.selectRowChange }}
                        columns={this.getColumns()}
                        dataSource={data}
                        bordered
                        footer={() => <Pagination total={total} current={pageNum} pageSize={pageSize} onChange={this.pageChange}/>}
                    />
                </GroupBox>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/personal/log/index/DetailModal.jsx